import {Component, Input} from '@angular/core';
import {LoadingController, NavController} from 'ionic-angular';
import { Chart } from 'angular-highcharts';
import {highChartSummary} from '../../model/graphing/highsoft/highChartSummary';
import {SolarAnalyticsData} from '../../providers/solar-analytics-data';
import {LoggerService} from '../../providers/logger-service';
//TODO: Wait for Highstocks or use this: https://forum.ionicframework.com/t/ionic-2-and-highcharts-modules/59365/9


declare var dataLayer: Array<any>;

@Component({
  selector: 'page-energy-summary-chart',
  templateUrl: 'energy-summary-chart.html',
})

export class EnergySummaryChart {


  @Input() energyData: highChartSummary;

  errorMessage: string = 'unable to load data from solar analytics for EnergySummaryChart';
  isDataAvailable:boolean = false;
  chart:Chart = null;


  constructor(public saDataService: SolarAnalyticsData,
              public nav: NavController,
              public loadingCtrl: LoadingController,
              private logger: LoggerService) {
    this.logger.log.debug('Hello EnergySummaryChart');

  }


  ionViewDidLoad() {

    this.logger.log.debug('ionViewDidLoad');

    let loader = this.loadingCtrl.create({
      content: 'Retrieving your data..',
    });

    this.logger.log.debug('loader.present()');
    loader.present().then(() => {

      this.saDataService.getSolarAnalyticsGraphChartHSData().subscribe(
        res => {
          this.energyData = res;
          this.isDataAvailable = true;
          this.chart = this.energyData.chart;
          this.logger.log.debug('assigned result call');
          this.logger.log.debug(this.isDataAvailable);
          this.logger.log.debug(this.energyData);

          this.logger.log.debug('dismisses the loading controller');
          loader.dismiss();
        },
        err => console.warn(this.errorMessage),
        () => {

          this.logger.log.debug('finished call');
        }
      );

    });


    this.logger.log.debug('ionViewDidLoad finished');
    this.logger.log.debug(this.isDataAvailable);
    this.logger.log.debug(this.energyData);

    dataLayer.push({
      'screenPath': 'energy-summary-chart',
      'screenName': 'EnergySummaryChart'
    });
    dataLayer.push({'event': 'appScreenView'});

  };



  //TODO: 3. error handling


// TODO: destroy subscription when you're moving out of this view.


}



// WEBPACK FOOTER //
// ./src/pages/energy-summary-chart/energy-summary-chart.ts